<div class="template-container">
    <div class="page-header">
        <div class="title-section">
            <h2 class="page-title">Configuration du Template FAT{{ template?.version ? ' (' + template!.version + ')' :
                '' }}</h2>
            <p class="page-subtitle">Gérez les catégories, sous-catégories et champs du template.</p>
        </div>
        <div class="header-actions">
            <span *ngIf="template" class="status-badge" [class.status-draft]="isDraft"
                [class.status-validated]="isValidated">
                {{ templateStatus }}
            </span>
            <span *ngIf="saving" class="saving-indicator">
                <mat-icon aria-hidden="true" class="spin">sync</mat-icon>
                Sauvegarde...
            </span>
            <button *ngIf="canCreateNewVersion" class="btn btn-outline btn-with-icon" (click)="onCreateTemplate()">
                <mat-icon aria-hidden="true">add</mat-icon>
                Créer un nouveau template
            </button>
            <button *ngIf="template" class="btn btn-outline btn-with-icon" (click)="onExport()" [disabled]="loading">
                <mat-icon aria-hidden="true">download</mat-icon>
                Exporter Excel
            </button>
            <button *ngIf="canEdit" class="btn btn-outline btn-with-icon" (click)="addCategory()">
                <mat-icon aria-hidden="true">playlist_add</mat-icon>
                Ajouter une Catégorie
            </button>
            <button *ngIf="isLatest && !isValidated" class="btn btn-success btn-with-icon"
                [disabled]="loading || saving" (click)="onValidate()">
                <mat-icon aria-hidden="true">check_circle</mat-icon>
                Valider
            </button>
        </div>
    </div>

    <div class="template-layout">
        <!-- Sidebar avec la liste des versions -->
        <aside class="versions-sidebar card" [class.collapsed]="isSidebarCollapsed()">
            <div class="sidebar-header">
                <h3>Historique des versions</h3>
                <button class="btn-toggle-sidebar" (click)="toggleSidebar()" title="Réduire/Agrandir">
                    <mat-icon>{{ isSidebarCollapsed() ? 'chevron_right' : 'chevron_left' }}</mat-icon>
                </button>
            </div>
            <div class="versions-list">
                <div *ngIf="loading && !availableVersions.length" class="loading-sidebar">Chargement...</div>
                <div *ngIf="!loading && !availableVersions.length" class="loading-sidebar">Aucune version</div>
                <button *ngFor="let v of availableVersions" [class.active]="v === selectedVersion"
                    (click)="onVersionChange(v)" class="version-item" type="button">
                    <span class="version-badge">Version</span>
                    <span class="version-name">{{ v }}</span>
                    <span *ngIf="v === availableVersions[0]" class="latest-label">Dernière</span>
                </button>
            </div>
        </aside>

        <!-- Contenu principal -->
        <div class="main-template-content">
            <div *ngIf="!loading && template && !isLatest && selectedVersion" class="alert alert-error">Vous consultez
                une version historique ({{selectedVersion}}). Les modifications sont désactivées. Sélectionnez la
                dernière version pour éditer.</div>
            <div *ngIf="!loading && template && isLatest && isValidated" class="alert alert-warning">Cette version
                ({{selectedVersion}}) a été validée. Les modifications sont bloquées. Créez une nouvelle version pour
                apporter des modifications.</div>
            <div *ngIf="successMessage" class="alert alert-success">{{ successMessage }}</div>
            <div *ngIf="errorMessage" class="alert alert-error">{{ errorMessage }}</div>

            <div class="categories-tabs" *ngIf="template">
                <mat-tab-group [(selectedIndex)]="activeCategoryIndex">
                    <mat-tab *ngFor="let cat of template.categories; let i = index">
                        <ng-template mat-tab-label>
                            <span class="tab-label">{{ cat.name }}</span>
                        </ng-template>

                        <div class="card category-card">
                            <div class="card-header">
                                <input [(ngModel)]="cat.name" (ngModelChange)="triggerAutoSave()"
                                    placeholder="Nom de la catégorie" class="title-input" [readonly]="!canEdit">
                                <div class="card-actions" *ngIf="canEdit">
                                    <button class="btn-icon" (click)="addSubcategory(cat)"
                                        title="Ajouter sous-catégorie" type="button">
                                        <mat-icon aria-hidden="true">add</mat-icon>
                                    </button>
                                    <button class="btn-icon delete" (click)="removeCategory(i)"
                                        title="Supprimer catégorie" type="button">
                                        <mat-icon aria-hidden="true">delete</mat-icon>
                                    </button>
                                </div>
                            </div>

                            <div class="subcategories-list">
                                <div *ngFor="let sub of cat.subcategories; let j = index" class="subcategory-block">
                                    <div class="sub-header">
                                        <div class="sub-title-with-icon">
                                            <mat-icon class="sub-icon" aria-hidden="true">folder</mat-icon>
                                            <input [(ngModel)]="sub.name" (ngModelChange)="triggerAutoSave()"
                                                placeholder="Nom de la sous-catégorie" class="subtitle-input"
                                                [readonly]="!canEdit">
                                        </div>
                                        <div class="sub-actions" *ngIf="canEdit">
                                            <button class="btn btn-outline btn-sm btn-with-icon" (click)="addField(sub)"
                                                type="button">
                                                <mat-icon aria-hidden="true">add</mat-icon>
                                                Ajouter un Champ
                                            </button>
                                            <button class="btn-icon delete" (click)="removeSubcategory(cat, j)"
                                                type="button">
                                                <mat-icon aria-hidden="true">delete</mat-icon>
                                            </button>
                                        </div>
                                    </div>

                                    <div class="fields-container" *ngIf="sub.fields.length > 0">
                                        <table class="fields-table">
                                            <thead>
                                                <tr>
                                                    <th style="width: 10%">Ordre</th>
                                                    <th style="width: 25%">Nom du champ</th>
                                                    <th style="width: 15%">Type</th>
                                                    <th style="width: 10%">Comptage</th>
                                                    <th style="width: 10%">Type Transfo</th>
                                                    <th style="width: 15%">Configuration</th>
                                                    <th style="width: 20%">Résultats possibles</th>
                                                    <th *ngIf="canEdit" style="width: 15%">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let field of getPaginatedFields(sub); let k = index">
                                                    <td><input type="number" [(ngModel)]="field.orderId"
                                                            (ngModelChange)="field.orderId = field.orderId < 1 ? 1 : field.orderId; triggerAutoSave()"
                                                            class="table-input" [readonly]="!canEdit" min="1"></td>
                                                    <td><input [(ngModel)]="field.name"
                                                            (ngModelChange)="triggerAutoSave()" class="table-input"
                                                            [readonly]="!canEdit"></td>
                                                    <td>
                                                        <div class="select-wrapper">
                                                            <select [(ngModel)]="field.type"
                                                                (ngModelChange)="onFieldTypeChange(field)" class="table-input"
                                                                [disabled]="!canEdit">
                                                                <option value="ACTION">Action</option>
                                                                <option value="PHOTO">Photo(s)</option>
                                                                <option value="DOCUMENT">Document</option>
                                                            </select>
                                                            <span class="caret">▾</span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="select-wrapper">
                                                            <select [(ngModel)]="field.comptage"
                                                                (ngModelChange)="triggerAutoSave()" class="table-input"
                                                                [disabled]="!canEdit">
                                                                <option value="">-</option>
                                                                <option value="HT">HT</option>
                                                                <option value="BT">BT</option>
                                                            </select>
                                                            <span class="caret">▾</span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="select-wrapper">
                                                            <select [(ngModel)]="field.transformerType"
                                                                (ngModelChange)="triggerAutoSave()" class="table-input"
                                                                [disabled]="!canEdit">
                                                                <option value="">-</option>
                                                                <option value="HUILE">Huile</option>
                                                                <option value="SEC">Sec</option>
                                                            </select>
                                                            <span class="caret">▾</span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="config-cell">
                                                            <label class="checkbox-label" [class.disabled]="!canEdit">
                                                                <input type="checkbox"
                                                                    [(ngModel)]="field.commentMandatory"
                                                                    (ngModelChange)="triggerAutoSave()"
                                                                    [disabled]="!canEdit">
                                                                Commentaire Obligatoire
                                                            </label>
                                                            <div *ngIf="field.commentMandatory"
                                                                class="comment-placeholder-container">
                                                                <label class="mini-label">Commentaire attendu:</label>
                                                                <input [(ngModel)]="field.commentPlaceholder"
                                                                    (ngModelChange)="triggerAutoSave()"
                                                                    class="table-input mini-wide" [readonly]="!canEdit"
                                                                    placeholder="Ex: Précisez le motif...">
                                                            </div>
                                                            <div *ngIf="field.type === 'PHOTO' || field.type === 'DOCUMENT'"
                                                                class="min-photos-container">
                                                                <label class="mini-label">{{ field.type === 'PHOTO' ?
                                                                    'Nb photos min:' : 'Nb docs min:' }}</label>
                                                                <input type="number" [(ngModel)]="field.minPhotosNbr"
                                                                    (ngModelChange)="triggerAutoSave()"
                                                                    class="table-input mini" [readonly]="!canEdit"
                                                                    min="1">
                                                            </div>
                                                            <label *ngIf="field.type === 'DOCUMENT'" class="checkbox-label"
                                                                [class.disabled]="!canEdit">
                                                                <input type="checkbox"
                                                                    [(ngModel)]="field.includeInReportAnnexes"
                                                                    (ngModelChange)="triggerAutoSave()"
                                                                    [disabled]="!canEdit">
                                                                Ajouter aux annexes
                                                            </label>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="multi-select-container">
                                                            <label class="checkbox-label" [class.disabled]="!canEdit">
                                                                <input type="checkbox"
                                                                    [checked]="isResultSelected(field, 'Conforme')"
                                                                    (change)="toggleResultOption(field, 'Conforme')"
                                                                    [disabled]="!canEdit">
                                                                C
                                                            </label>
                                                            <label class="checkbox-label" [class.disabled]="!canEdit">
                                                                <input type="checkbox"
                                                                    [checked]="isResultSelected(field, 'Non Conforme')"
                                                                    (change)="toggleResultOption(field, 'Non Conforme')"
                                                                    [disabled]="!canEdit">
                                                                NC
                                                            </label>
                                                            <label class="checkbox-label" [class.disabled]="!canEdit">
                                                                <input type="checkbox"
                                                                    [checked]="isResultSelected(field, 'Non Applicable')"
                                                                    (change)="toggleResultOption(field, 'Non Applicable')"
                                                                    [disabled]="!canEdit">
                                                                NA
                                                            </label>
                                                        </div>
                                                    </td>
                                                    <td *ngIf="canEdit">
                                                        <button class="btn-icon delete"
                                                            (click)="removeField(sub, (subcategoryPageIndices[sub.name] || 0) * fieldPageSize + k)"
                                                            type="button">
                                                            <mat-icon aria-hidden="true">delete</mat-icon>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <mat-paginator *ngIf="sub.fields.length > fieldPageSize"
                                            [length]="sub.fields.length" [pageSize]="fieldPageSize"
                                            [pageIndex]="subcategoryPageIndices[sub.name] || 0"
                                            (page)="onPageChange(sub, $event)" [hidePageSize]="true">
                                        </mat-paginator>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </mat-tab>
                </mat-tab-group>
            </div>
        </div>
    </div>
</div>


<app-confirm-dialog *ngIf="showConfirmValidate" title="Valider le template"
    message="Voulez-vous vraiment valider cette version ? Une fois validée, aucune modification ne sera possible et vous devrez créer une nouvelle version pour apporter des changements."
    confirmLabel="Valider" (confirmed)="confirmValidate()" (cancelled)="showConfirmValidate = false">
</app-confirm-dialog>

<app-confirm-dialog *ngIf="showConfirmDelete" title="Confirmation de suppression" [message]="deleteMessage"
    (confirmed)="confirmDelete()" (cancelled)="cancelDelete()">
</app-confirm-dialog>

<app-create-template-dialog *ngIf="showCreateDialog" [canDuplicate]="!!template" [uploading]="loading"
    (choice)="handleCreateChoice($event)" (importFile)="handleImport($event)" (cancelled)="showCreateDialog = false">
</app-create-template-dialog>
